import React, { Component } from "react";
import '../assets/templates/TextPagesHL.css';
import LessonInstruction from "../containers/instruction/LessonInstruction";

class TextPagesHL extends Component {
  constructor(props) {
    super(props)

    this.state = {
    }
  }

  getHilighted(text) {
    let splitText = text.split(/( )/)
    let textObj = []
    for (let i = 0; i < splitText.length; i++) {
      if (splitText[i].includes("[") || splitText[i].includes("]")) {
        textObj.push({ word: splitText[i].replace("[", "").replace("]", ""), highLight: true })
      } else {
        textObj.push({ word: splitText[i], highLight: false })
      }
    }
    return textObj
  }


  render() {
    const { data, audioUrl } = this.props;

    // temporary - sets background to white color
    const bgColor = data.type === "instruction" ? "new-bg-color" : "";
    const containerClasses = `default-card ${bgColor}`;

    return (
      <div className={containerClasses}>
        {
          data.type === 'instruction'
            ?
            <>
              <LessonInstruction
                instructionText={data.instruction}
                audioUrl={audioUrl}
              />
            </>
            :

            <div>
              {

                data.en.split("\r\n").map((item, index) => {
                  return (
                    <div key={index} className="text-pages-container">
                    {
                      this.getHilighted(item).map((w)=>{
                        return(
                            <h2 style={{color: w.highLight ? 'rgb(47, 157, 201)':'white'}}>
                               { w.word }
                            </h2>
                        )
                    })
                      }
                     </div>
                      
                  );
                })
              }
            </div>

        }
      </div>
    )
  }
}

export default TextPagesHL;
